import loginConf from './_confLogin';
import storeConf from './_confStore';
import webStoreConf from './_confWebStore';
import passportConf from './_confPassport';
import officialStoreConf from './_confOfficialStore';
import termsConf from './_confTerms';
import cashConf from './_confCash';
import jpLoginConf from './_confJpLogin';
import officialWebStoreConf from './_confOfficialWebStore';
import officialTopup from './_confOfficialTopup';
export default {
  login: loginConf,
  store: storeConf,
  webStore: webStoreConf,
  passport: passportConf,
  officialStore: officialStoreConf,
  terms: termsConf,
  jpLogin: jpLoginConf,
  officialWebStore: officialWebStoreConf,
  cash: cashConf,
  officialTopup: officialTopup,
};
